



















































































































import { Component, Ref, Vue } from "vue-property-decorator";
import {
  AttachmentHostType,
  AuditFlowScope,
  ActivityApplyDto,
} from "@/api/appService";
import api from "@/api";
import moment from "moment";
import AttachmentsView from "@/components/AttachmentsView/index.vue";
import { AuditBodyDto } from "@/utils/customDto";

import AuditBlock, { AuditApi } from "@/components/Audit/AuditBlock.vue";

@Component({
  name: "ActivityCheckInDetail",
  components: {
    AuditBlock,
    AttachmentsView,
  },
  filters: {
    formatStatus(status?: string) {
      switch (status) {
        case "Draft":
          return "草稿";

        case "Published":
          return "已发布";

        case "Deleted":
          return "已删除";
      }
    },
  },
})
export default class ActivityCheckInDetail extends Vue {
  dataId?: number;
  detail: any = {
    activity: {},
    applyUser: {},
    userExtend: {},
    volunteer: {},
  };
  baseURL: any;
  loading = true;

  created() {
    if (this.$route.params.id) {
      this.dataId = Number(this.$route.params.id);
      this.fetchDetail();
    }
  }

  // 获取详情
  async fetchDetail() {
    await api.activityApply.get({ id: this.dataId }).then((res) => {
      this.loading = false;
      this.detail = {
        ...res,
        activity: res.activity || {},
        applyUser: res.applyUser || {
          surname: res.surname,
          name: res.surname,
          phoneNumber: res.phoneNumber,
        },
        userExtend: res.userExtend || {},
        volunteer: res.volunteer || {},
      };
    });
  }

  getTime(item: any) {
    return moment(item).format("HH:mm");
  }

  getApplyName(detail: ActivityApplyDto | any) {
    return (
      detail?.surname ||
      detail?.applyUser?.surname ||
      detail?.applyUser?.name ||
      ""
    );
  }

  getApplyPhone(detail: ActivityApplyDto | any) {
    return detail?.phoneNumber || detail?.applyUser?.phoneNumber || "";
  }

  // 下载附件
  downLoad(item: any) {
    window.location.href = `${this.baseURL}/api/services/app/Attachment/Download?id=${item.id}`;
  }

  get auditApi() {
    return {
      canAudit: api.activityApply.canAudit,
      userAudit: api.activityApply.audit,
    } as AuditApi;
  }
}
